import classnames from "classnames";
import styles from "./NoisyText.css";
import { withTranslation } from "../translation";
import PropTypes from "prop-types";

const NoisyText = ({ enableComplianceVariant, formatTranslation }) => {
  const titleKey = enableComplianceVariant
    ? "alt_marketing_compliant_quick_join_overlay_title_web"
    : "quick_join_overlay_title_web";
  const a11yTitleKey = enableComplianceVariant
    ? "alt_marketing_compliant_quick_join_overlay_title_web_accessible"
    : "quick_join_overlay_a11y_title_web";

  return (
    <div
      className={classnames(styles.noisyTextContainer, {
        [styles.noisyTextContainerCompliance]: enableComplianceVariant
      })}
      aria-label={formatTranslation(a11yTitleKey)}
    >
      {formatTranslation(titleKey)
        .split("\n")
        .map((text, i) => (
          <span
            key={`${i}-${text.trim()}`}
            className={styles.noisyText}
            aria-hidden="true"
          >
            {text.trim()}
          </span>
        ))}
    </div>
  );
};

NoisyText.propTypes = {
  enableComplianceVariant: PropTypes.bool,
  formatTranslation: PropTypes.func
};

export default withTranslation(NoisyText);
